import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        <section className="hero">
          <div className="hero-text">
            <div className="hero-line1">NEW IN</div>
            <div className="hero-line2">TRANSITIONAL KNITS</div>
            <Link to="/shop" onClick={toTop} className="hero-link">
              SHOP NOW
            </Link>
          </div>
        </section>

        <section className="new-arrivals">
          <h2 className="section-title">New Arrivals</h2>
          <div className="product-grid">
            {productData.slice(0, 9).map((p) => (
              <div key={p.id} className="product-card">
                <Link
                  to={`/shopDetails/${p.id}`}
                  onClick={toTop}
                  className="image-link"
                >
                  <div className="image-wrap">
                    <img src={p.images?.[0] || p.image} alt={p.name} />
                  </div>
                </Link>
                <div className="prod-meta">
                  <div className="prod-name">{p.name}</div>
                  <div className="prod-price">€{Number(p.price).toLocaleString("en-US")}</div>
                  <div className="sizes">
                    {(p.size || []).map((s) => (
                      <span key={s} className="size">
                        {s}
                      </span>
                    ))}
                  </div>
                  <div className="sizes">
                    {(p.colors || []).map((s) => (
                      <span key={s} className="size">
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="split-banners">
          <Link to="/shop" onClick={toTop} className="banner banner1">
            <div className="caption">LIGHT WASH DENIM</div>
            <div className="cta">SHOP NOW</div>
          </Link>
          <Link to="/shop" onClick={toTop} className="banner banner2">
            <div className="caption">RAW SILK TEES</div>
            <div className="cta">SHOP NOW</div>
          </Link>
        </section>

        <section className="full-banner">
          <div className="full-banner-text">
            <div className="fb-title">Spring Stripes</div>
            <div className="fb-sub">
              Easy transitional pieces made for living
            </div>
            <Link to="/shop" onClick={toTop} className="fb-link">
              SHOP NOW
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
